//src/components/ProductDetails.js

import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { itemContext } from "../context/ItemContext";

const ProductDetails = () => {
  const { products } = useContext(itemContext);
  const { id } = useParams();
  const product = products.find((product) => product._id === id);

  if (!product) return <div>Product not found</div>;

  return (
    <div className="product-details">
      <h2>{product.name}</h2>
      <img src={product.image} alt={product.name} />
      <p>{product.description}</p>
      <p>Price: ${product.price.toFixed(2)}</p>
    </div>
  );
};

export default ProductDetails;
